import { StyledFilters, StyledHeader, StyledSearch } from './Header.style';
import ResourceTypeToggler from './ResourceTypeToggler';
import ExportButton from './ExportButton/ExportButton';
import { VALIDATION_RULES } from 'common/validations/validation.rules';
import { SearchInputWithValidation } from 'common/validations/input-components';

const Header = ({
  resourceType,
  setResourceType,
  keyword,
  setKeyword,
  tableSortBy
}) => {
  return (
    <StyledHeader>
      <StyledFilters>
        <ResourceTypeToggler
          resourceType={resourceType}
          onChange={resourceType => setResourceType(resourceType)}
        />
      </StyledFilters>
      <StyledSearch>
        <SearchInputWithValidation
          width='95%'
          height='3rem'
          placeholder='Type name'
          value={keyword}
          onChange={value => setKeyword(value)}
          validationRules={[VALIDATION_RULES.minLength(2)]}
        />
      </StyledSearch>
      <ExportButton
        resourceType={resourceType}
        keyword={keyword}
        tableSortBy={tableSortBy}
      />
    </StyledHeader>
  );
};

export default Header;
